(function () {
  if (!window.peSocialProofData || !window.peSocialProofData.length) return;

  var pageLoadedAt = Date.now();
  var order = window.peSocialProofData.slice();

  // Fisher-Yates shuffle so the order isn't identical on every visit.
  for (var i = order.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = order[i];
    order[i] = order[j];
    order[j] = tmp;
  }

  var idx = 0;
  var dismissed = false;

  function minutesAgoText(base) {
    var elapsedMin = Math.floor((Date.now() - pageLoadedAt) / 60000);
    var mins = base + elapsedMin;
    if (mins < 1) return 'hace instantes';
    if (mins === 1) return 'hace 1 minuto';
    return 'hace ' + mins + ' minutos';
  }

  function buildToast() {
    var el = document.createElement('div');
    el.id = 'pe-social-proof-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<button type="button" id="pe-social-proof-close" aria-label="Cerrar">&times;</button>' +
      '<div class="pe-social-proof-icon">✓</div>' +
      '<div class="pe-social-proof-text">' +
      '<strong id="pe-social-proof-name"></strong>' +
      '<span> acaba de comprar su protocolo</span>' +
      '<div class="pe-social-proof-meta"><span id="pe-social-proof-time"></span></div>' +
      '</div>';
    document.body.appendChild(el);
    document.getElementById('pe-social-proof-close').addEventListener('click', function () {
      dismissed = true;
      hideToast();
    });
    return el;
  }

  function hideToast() {
    var el = document.getElementById('pe-social-proof-toast');
    if (el) el.classList.remove('pe-social-proof-visible');
  }

  function showToast() {
    if (dismissed) return;
    var data = order[idx % order.length];
    idx++;
    var el = document.getElementById('pe-social-proof-toast') || buildToast();
    document.getElementById('pe-social-proof-name').textContent = data.name + ', de ' + data.city + ',';
    document.getElementById('pe-social-proof-time').textContent = minutesAgoText(data.baseMinutes);
    requestAnimationFrame(function () {
      el.classList.add('pe-social-proof-visible');
    });
    setTimeout(hideToast, 6000);
  }

  function loop() {
    if (dismissed) return;
    showToast();
    setTimeout(function () {
      if (dismissed) return;
      var wait = 8000 + Math.floor(Math.random() * 12000);
      setTimeout(loop, wait);
    }, 6000);
  }

  // Primer aviso a los 4 segundos de cargada la página.
  setTimeout(loop, 4000);
})();
